import { RequestItinerary } from 'src/types'

export enum MyTeamActionTypes {
  GET_MY_TEAM = '@myTeam/GET_MY_TEAM',
  GET_MY_TEAM_FAILURE = '@myTeam/GET_MY_TEAM_FAILURE',
  GET_MY_TEAM_SUCCESS = '@myTeam/GET_MY_TEAM_SUCCESS'
}

export interface ResponseDataMyTeam {
  request_itinerary: RequestItinerary[]
}

export interface MyTeamState {
  error: boolean
  loading: boolean
  list: RequestItinerary[]
}
